import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TravelRoute } from 'src/app/models/travel-route';
import { TravelRouteService } from 'src/app/services/travel-route.service';
import { Expense } from 'src/app/models/expense';
import { ExpenseService } from 'src/app/services/expense.service';

@Component({
  selector: 'app-route-edit',
  templateUrl: './route-edit.component.html',
  styleUrls: ['./route-edit.component.css']
})
export class RouteEditComponent implements OnInit {

  loading:boolean = false;
  route:TravelRoute;
  casetas:Expense[] = [];
  caseta:Expense;

  constructor(actRoute:ActivatedRoute, private routeServ:TravelRouteService, private expenseServ:ExpenseService) { 
    this.loading = true;
    actRoute.params.subscribe(params => {
      this.routeServ.getRoute(params.id).then(route => {
        this.route = route;
        this.loading = false;
      });
    });
  }

  ngOnInit() {
    this.expenseServ.getExpenses("type", "Viaje").then(expenses => {
      this.casetas = expenses.filter(exp => exp.expense_type.name == 'Casetas');
      this.caseta = this.casetas[0];
    });
  }

  removeExp(exp) {
    this.route.expenses = this.route.expenses.filter(e => e.id != exp.id);
  }

  addExp() {
    this.route.expenses.push(this.caseta);
  }

  save() {
    this.loading = true;
    this.route.expenses = this.route.expenses.map(exp => exp.id);
    this.routeServ.putTravelRoute(this.route)
      .then(route => {
        this.route = route;
        this.loading = false;
      });
  }

}
